// eslint-disable-next-line
import React, { Fragment } from 'react';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaHttpClientSearch } from '../../../code/ArcaHttpClientSearch';
import { ArcaHttpClientEmail } from '../../../code/ArcaHttpClientEmail';
import { InputField } from '../Fields/InputField';
import { EmailListPanel } from './EmailListPanel';
import { MdEmail } from 'react-icons/md';
import { StatusBar } from '../StatusBar';


export class EmailViewPanel extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            findings: null,
            emails: null,
            isError: false,
            message: null
        };
    }

    async componentDidMount() {
    }


    async performSearch(searchString, valid) {

        if (valid && searchString.length < 3) {
            return;
        }

        await ArcaHttpClientSearch.Search(
            searchString,
            (findings => this.setState({ findings, emails: null })),
            (msg => this.setState({ isError: true, message: msg }))
        )
    }

    userClicked(id) {
        ArcaHttpClientEmail.GetByPersonAsync(
            id,
            ((emails) => this.setState({ emails })),
            (() => this.setState({ isError: true, message: 'No emails' })),
            ((msg) => alert(msg))
        );

        this.setState({ personId: id })
    }


    render() {

        let { findings, emails, isError, message, personId } = this.state;

        return (
            <Fragment>
                <h1>User list</h1>
                <StatusBar message={message} isError={isError} />

                <InputField
                    fieldname='Search ..'
                    regularExpression='free'
                    warnText='Invalid search text format'
                    mandatory={false}
                    showHeader={false}
                    onUpdate={this.performSearch.bind(this)}
                    fieldValid={true} />

                {findings && !emails ?
                    <table className='table table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Address line 1</th>
                                <th>Postcode</th>
                                <th>Pet name</th>
                                <th>Type</th>
                            </tr>
                        </thead>
                        <tbody>
                            {findings ? findings.map((f, k) =>
                                <tr key={k}>
                                    <td>
                                        <span
                                            className='minilink'
                                            onClick={() => this.userClicked(f.Id)}>
                                            <MdEmail />
                                            {f.FullName}
                                        </span>
                                    </td>
                                    <td>{f.AddressLine1}</td>
                                    <td>{f.Postcode}</td>
                                    <td>{f.PetName}</td>
                                    <td>{f.Type}</td>
                                </tr>
                            )
                                : null}
                        </tbody>
                    </table>
                    : null}

                {emails
                    ? <EmailListPanel personId={personId} />
                    : null}

            </Fragment>
        );
    }
}